const getters = {
  fontSize: state => state.app.fontSize,
  screenWidth: state => state.app.screenWidth,
  screenHeight: state => state.app.screenHeight,
  token: state => state.user.token,
  userId: state => state.user.id,
  customerId: state => state.user.customerId,
  name: state => state.user.name,
  roles: state => state.user.roles,
  userType: state => state.user.userType,
  addRouters: state => state.permission.addRouters,
  showWarning: state => state.permission.showWarning,
  permission_routers: state => state.permission.routers,
  // websocket相关
  openAnAccountUUID: state => state.webSocketUUID.openAnAccountUUID,
  rechargeUUID: state => state.webSocketUUID.rechargeUUID,
  refundUUID: state => state.webSocketUUID.refundUUID,
  controlAvailableUUID: state => state.webSocketUUID.controlAvailableUUID,
  controlSwitchUUID: state => state.webSocketUUID.controlSwitchUUID,
  // 批量充值
  customerUserMeterInfos: state => state.customerUserMeterInfo.customerUserMeterInfos,
  batchRechargeAmount: state => state.customerUserMeterInfo.batchRechargeAmount
}
export default getters
